import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SyncControls = ({ 
  isRunning, 
  isPaused, 
  onPause, 
  onResume, 
  onCancel, 
  canPause = true,
  canCancel = true 
}) => {
  const [showCancelDialog, setShowCancelDialog] = useState(false);

  const handleCancelClick = () => {
    setShowCancelDialog(true);
  };

  const handleConfirmCancel = () => {
    onCancel();
    setShowCancelDialog(false);
  };

  const handleCancelDialog = () => {
    setShowCancelDialog(false);
  };

  return (
    <>
      <div className="bg-surface border border-border rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className={`p-2 rounded-lg ${
              isRunning && !isPaused 
                ? 'bg-success/10 text-success' 
                : isPaused 
                ? 'bg-warning/10 text-warning' :'bg-surface-secondary text-text-muted'
            }`}>
              <Icon 
                name={
                  isRunning && !isPaused 
                    ? 'Play' 
                    : isPaused 
                    ? 'Pause' :'Square'
                } 
                size={20} 
              />
            </div>
            <div>
              <h3 className="text-lg font-medium text-text-primary">Sync Controls</h3>
              <p className="text-sm text-text-secondary">
                {isRunning && !isPaused 
                  ? 'Sync in progress...' 
                  : isPaused 
                  ? 'Sync paused' :'Sync stopped'
                }
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            {isRunning && (
              <>
                {!isPaused ? (
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={onPause}
                    disabled={!canPause}
                    iconName="Pause"
                    iconSize={16}
                  >
                    Pause
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    size="sm"
                    onClick={onResume}
                    iconName="Play"
                    iconSize={16}
                  >
                    Resume
                  </Button>
                )}
              </>
            )}
            
            <Button
              variant="danger"
              size="sm"
              onClick={handleCancelClick}
              disabled={!canCancel}
              iconName="X"
              iconSize={16}
            >
              Cancel
            </Button>
          </div>
        </div>

        {/* Status Information */}
        <div className="mt-4 pt-4 border-t border-border">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
            <div>
              <span className="text-text-muted">Status:</span>
              <span className={`ml-2 font-medium ${
                isRunning && !isPaused 
                  ? 'text-success' 
                  : isPaused 
                  ? 'text-warning' :'text-text-secondary'
              }`}>
                {isRunning && !isPaused 
                  ? 'Running' 
                  : isPaused 
                  ? 'Paused' :'Stopped'
                }
              </span>
            </div>
            <div>
              <span className="text-text-muted">Started:</span>
              <span className="ml-2 text-text-primary">
                {new Date().toLocaleTimeString('en-US', {
                  hour12: false,
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
            <div className="col-span-2 lg:col-span-1">
              <span className="text-text-muted">Speed:</span>
              <span className="ml-2 text-text-primary">~2.5 tracks/sec</span>
            </div>
          </div>
        </div>
      </div>

      {/* Cancel Confirmation Dialog */}
      {showCancelDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-1050 p-4">
          <div className="bg-surface border border-border rounded-lg max-w-md w-full p-6">
            <div className="flex items-center space-x-3 mb-4">
              <div className="p-2 bg-error/10 rounded-lg">
                <Icon name="AlertTriangle" size={24} className="text-error" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-text-primary">Cancel Sync?</h3>
                <p className="text-sm text-text-secondary">This action cannot be undone</p>
              </div>
            </div>

            <p className="text-sm text-text-secondary mb-6">
              Are you sure you want to cancel the current sync operation? Any progress made so far will be lost, and you'll need to start over.
            </p>

            <div className="flex items-center justify-end space-x-3">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleCancelDialog}
              >
                Keep Syncing
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={handleConfirmCancel}
                iconName="X"
                iconSize={16}
              >
                Cancel Sync
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SyncControls;